module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-132.9ea0772.woff2";